import axios, { AxiosInstance } from "axios";
import axiosRetry from "axios-retry";

const BASE_URL = process.env.ABS_SCOREBOARD_URL;

const ScoreboardClient: AxiosInstance = axios.create({
  baseURL: BASE_URL,
});

axiosRetry(ScoreboardClient, {
  retries: 5,
  retryCondition: (error) => {
    console.log("Error fetching from API will retry...");
    return true;
  },
  retryDelay: (retryCount) => retryCount * 1000,
});

export default ScoreboardClient;
